import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_112: FaireProductEntity = {
  token: "starter_collection_112",
  type: "product",
  name: "Holiday Blend",
  brandName: "Canyon Coffee",
  imageUrl:
    '"https://cdn.faire.com/fastly/424ebb28ff6f2a7ae477c994dc3b56392d9c0bc3148c9c9b6159d8c5dc5ff922.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=1022',
  priceDollars: 22,
  msrpDollars: 44,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
